import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

export const SectionBox = ({ title, action, children }) => {
  const theme = useTheme();
  const hasBody = Boolean(children);

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.blueGray200.main}`,
        borderLeft: `5px solid ${theme.palette.blueGray200.main}`,
        borderRadius: 1,
        mt: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          py: 1,
          mx: 1,
          borderBottom: hasBody
            ? `2px solid ${theme.palette.blueGray200.main}`
            : "none",
        }}
      >
        <Typography fontSize={13} fontWeight={600}>
          {title}
        </Typography>
        {action}
      </Box>
      {hasBody && (
        <Box py={0.75} mx={1}>
          {children}
        </Box>
      )}
    </Box>
  );
};
